if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.currentVariant = null;
      this.cartesian = null;
      this.areAllSelectionsMade = false;
      this.qtyLabel = this.dataset.qtyLabel;
      this.qtyLabelPlural = this.dataset.qtyLabelPlural;
    }
    
    connectedCallback() {
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale   
      this.cartesian = JSON.parse(this.querySelector('template[data-cartesian]')?.content.textContent ?? '[]');
      this.atcButton = this.querySelector('[data-action="add-to-cart"]');
      this.form = this.querySelector(`form[action="${this.locale ? `/${this.locale}` : `` }/cart/add"]`);            
      if (!this.cartesian) return;
      
      this.currentVariant = this.cartesian[this.getCurrentOptionSet().toString()] || null;
      this.calculateAvailability();
      
      this.querySelector('[name="quantity"]').addEventListener('change', () => this.updatePriceDisplay());
            
      this.addEventListener('change', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          imageSwap,
          optionName,
          option
        } = clickedElement.dataset;
                
        switch (action) {
          case 'option-choice':
            this.currentVariant = this.cartesian[this.getCurrentOptionSet().toString()];
            
            this.variantShowEls_().forEach((el) => {
              if (Number(el.dataset.show) === Number(this.currentVariant.variant_json.id)) {
                el.style.display = null;
                if (el.dataset.qtyLabel) this.qtyLabel = el.dataset.qtyLabel;
                if (el.dataset.qtyLabelPlural) this.qtyLabelPlural = el.dataset.qtyLabelPlural;

                return;
              }
              el.style.display = 'none';
            });
            this.calculateAvailability();
            this.updatePriceDisplay();
            
            const optionNameDisplay = this.querySelectorAll(`[data-option-name-display="${option}"]`);
            if (optionName) optionNameDisplay.forEach(el => el.innerText = optionName);
            
            if (imageSwap) {
              window.dispatchEvent(new CustomEvent('product-form:variant-change', {
                detail: {
                  productId: this.form?.dataset.productId,
                  variant: this.currentVariant.variant_json
                }
              }));
            }
            
            const defaultQtySelection = this.querySelector(`[data-show="${this.currentVariant.variant_json.id}"] [data-bmps-qty] [data-default-selection]`);
            if (defaultQtySelection) defaultQtySelection.click();
          break;
        }
      });
      
      if (this.currentVariant && this.querySelector(`[data-show="${this.currentVariant.variant_json.id}"]`)) {
        const defaultQtySelection = this.querySelector(`[data-show="${this.currentVariant.variant_json.id}"] [data-bmps-qty] [data-default-selection]`);
        if (defaultQtySelection) defaultQtySelection.click();
        if (defaultQtySelection.dataset.qtyLabel) this.qtyLabel = defaultQtySelection.dataset.qtyLabel;
        if (defaultQtySelection.dataset.qtyLabelPlural) this.qtyLabelPlural = defaultQtySelection.dataset.qtyLabelPlural;
      } else {
        const defaultQtySelection = this.querySelector('[data-bmps-qty] [data-default-selection]');
        if (defaultQtySelection) defaultQtySelection.click();
      }
    }
    
    calculateAvailability() {
      if (this.currentVariant?.variant_json.available) {
        this.querySelector('[type="submit"][data-action="add-to-cart"]')?.removeAttribute('disabled');
      } else this.querySelector('[type="submit"][data-action="add-to-cart"]')?.setAttribute('disabled', true);
            
      this.classList.toggle('selection-needed', false);  

      if (!this.currentVariant) return;
      this.querySelector('select[name="id"]').value = this.currentVariant.variant_json.id;
    }
    
    updatePriceDisplay() {
      if (!this.currentVariant) return;
      const priceDisplays = document.querySelectorAll('[data-price]');
      const qtyDisplays = document.querySelectorAll('[data-quantity-display]');
      const servingsDisplays = this.querySelectorAll('[data-servings]');
      const currentQty = Number(this.querySelector('[name="quantity"]')?.value);

      qtyDisplays.forEach((el) => {
        el.innerText = `${currentQty} ${currentQty > 1 ? this.qtyLabelPlural : this.qtyLabel}`;
      });

      const priceCents = Number(this.currentVariant.variant_json.price);
      const compareAtCents = Number(this.currentVariant.variant_json.compare_at_price);

      let discountValue = 0;

      if (compareAtCents > priceCents && compareAtCents > 0) {
        const discountCents = compareAtCents - priceCents;
        discountValue = Math.round((discountCents * 100) / compareAtCents);
      }

      const compareAtPrice = Number(compareAtCents / 100);
      const fullPrice = Number(priceCents) / 100;
      let buyMorePayLess = document.querySelectorAll('[data-bmps-qty][data-bmps-price]');

      if (document.querySelector('[data-variant-bmps]')) {
        buyMorePayLess = document.querySelectorAll(
          `[data-bmps-qty][data-bmps-price][data-variant-bmps="${this.currentVariant.variant_json.id}"]`
        );
      }

      const saveLabel = this.dataset.saveLabel;
      let percentageDiscount = 0;
      let bmpsPrice = null;

      buyMorePayLess.forEach((x) => {
        const thisQty = Number(x.dataset.bmpsQty);
        const thisPrice = Number(x.dataset.bmpsPrice);
        if (thisQty <= currentQty && (thisPrice < bmpsPrice || bmpsPrice === null)) {
          bmpsPrice = thisPrice;
          percentageDiscount = x.dataset.bmpsCardinal;
        }
      });

      const effectiveUnitPrice = bmpsPrice !== null ? bmpsPrice / 100 : fullPrice;

      servingsDisplays.forEach((x) => {
        const servingsPerUnit = Number(this.currentVariant.servings_per_unit);
        if (!servingsPerUnit) return;
        const perServingPrice = effectiveUnitPrice / servingsPerUnit;
        x.textContent = `${this.dataset.currencySymbol}${perServingPrice.toFixed(2)} per serving`;
      });

      priceDisplays.forEach((el) => {
        el.innerHTML = `
          <span class="price ${compareAtPrice > fullPrice || bmpsPrice ? `text-cardinal` : ``}">
            ${this.dataset.currencySymbol}${bmpsPrice ? ((bmpsPrice / 100) * currentQty).toFixed(2) : (fullPrice * currentQty).toFixed(2)}
          </span>
          ${compareAtPrice > fullPrice || bmpsPrice ?`
            <span class="discount-price">
              ${this.dataset.currencySymbol}${(compareAtPrice * currentQty).toFixed(2)}
            </span>
            <span class="badge bg-primaryDark !tracking-normal md:text-[13px] ml-1.5 text-white text-sm font-bold font-heading px-[9px] leading-[0.8] py-2 rounded text-center uppercase">
              ${saveLabel} ${bmpsPrice ? percentageDiscount : discountValue}%
            </span>
          `
          : ''}

        `;
      });
    }

    variantShowEls_() {
      if (!this.variantIds) {
        this.variantIds = new Set(Object.values(this.cartesian).map(({ variant_json }) => String(variant_json.id)));
      }
      const roots = [document, ...[...document.querySelectorAll('template')].map((t) => t.content)];
      return roots
        .flatMap((root) => [...root.querySelectorAll('[data-show]')])
        .filter((el) => this.variantIds.has(el.dataset.show));
    }

    getCurrentOptionSet(position, option) {
      let thisOptionSet;
        thisOptionSet = [...this.querySelectorAll('select[data-action="option-choice"], [data-action="option-choice"]:checked')].map(({ value }) => value);
      if (position && option) {
        const optionIndex = Number(position) - 1;
        thisOptionSet[optionIndex] = option;
      }
      return thisOptionSet;
    }
    
    getMatchingVariant(position, option) {
      const optionIndex = Number(position) - 1;
      let thisOptionSet = this.getCurrentOptionSet();
      thisOptionSet[optionIndex] = option;
      return this.cartesian[thisOptionSet.toString()]
    }
  }
  
  customElements.define('product-form', ProductForm);
}
